import { useApi } from './useApi'
import { uploadMetadataImage } from './useLinkMetadata'

// Defaults por tipo de enlace (salida, estudios, etc.) que valen como piso para
// todas las congregaciones. Sólo responde a superusuarios; comparte biblioteca
// de imágenes con useSiteMetadata (owner __site__).
export const useAdminLinkMetadata = () => {
  const api = useApi()

  const getLinkMetadata = () => api.get('/api/admin/link-metadata')

  const saveLinkMetadata = (payload) => api.put('/api/admin/link-metadata', payload)

  const resetLinkMetadata = (type) => api.del(`/api/admin/link-metadata/${type}`)

  const getPreview = (type) => api.get(`/api/admin/link-metadata/preview?type=${type}`)

  const uploadImage = (file) => uploadMetadataImage('/api/admin/site-metadata/images', file)

  const deleteImage = (id) => api.del(`/api/admin/site-metadata/images/${id}`)

  return { getLinkMetadata, saveLinkMetadata, resetLinkMetadata, getPreview, uploadImage, deleteImage }
}
